import { defineMessages } from "react-intl";

export default defineMessages({
  completeYourInformation: {
    id: "configurePayment.completeYourInformation",
    defaultMessage: "Complete your information",
  },
  setupErrorTitle: {
    id: "configurePayment.setupErrorTitle",
    defaultMessage:
      "Error setting up payment. Please try another payment method.",
  },
});
